/**
 * Resolve media URLs to the remote file server.
 * Handles both old local paths (/uploads/...) and new remote URLs.
 */
const MEDIA_URL = process.env.REACT_APP_MEDIA_URL;
const API = process.env.REACT_APP_BACKEND_URL;

export function resolveMediaUrl(path) {
  if (!path) return '';
  // Any absolute URL (CDN, external, etc.) — pass through unchanged
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  // Local path like /uploads/generated/xxx.webp
  if (path.startsWith('/uploads/')) return `${MEDIA_URL}${path.slice('/uploads'.length)}`;
  // Path like /api/static-uploads/xxx
  if (path.startsWith('/api/static-uploads/')) return `${MEDIA_URL}${path.slice('/api/static-uploads'.length)}`;
  // Bare filename like generated/xxx.webp
  if (!path.startsWith('/')) return `${MEDIA_URL}/${path}`;
  // Fallback
  return `${API}${path}`;
}

export function getGeneratedImage(name) {
  return `${MEDIA_URL}/generated/${name}.webp`;
}

export { MEDIA_URL };
export default resolveMediaUrl;
